<template>
    <div class="">
        <div v-if="bannersOutstanding && bannersOutstanding.length <= 3" >
            <slick v-if="bannersOutstanding && bannersOutstanding.length" ref="slick" :options="slickOptionsBannerOutstandingV" class=" slick-vue mb-3">
                <div v-for="(bannerOutstanding, index) in bannersOutstanding" :key="index" v-if="index < 10" class="px-1 px-mg-2 col-3 col-sm-3 col-lg-2">
                    <div class="cursor-pointer mx-1 mx-md-3 mx-lg-4 pb-3">
                        <a :id="'outstanding-banner-' + (index+1)" :title="bannerOutstanding.name" :href="bannerOutstanding.cta_link" target="_self" class="d-flex justify-content-center  w-100 mb-2 ">
                            <img :src="bannerOutstanding.image" :alt="bannerOutstanding.name" class="rounded-4 w-100 h-100">
                        </a>
                        <a :id="bannerOutstanding.id + '-boton-aqui'" :title="bannerOutstanding.name" :href="bannerOutstanding.cta_link" target="_self" class="fs-6 text-indigo text-title-bat text-decoration-none fw-bold border-blue-bottom border-2 pb-2 text-btn-outstanding">{{bannerOutstanding.cta_text}} ></a>
                    </div>
                </div>
            </slick>
        </div>
        <div v-if="bannersOutstanding && bannersOutstanding.length > 4">
            <slick v-if="bannersOutstanding && bannersOutstanding.length" ref="slick" :options="slickOptionsBannerOutstanding" class=" slick-vue slick-outstanding-home mb-3">
                <div v-for="(bannerOutstanding, index) in bannersOutstanding" :key="index" v-if="index < 10" class="px-1 px-mg-2 col-3 col-sm-3 col-lg-2">
                    <div class="cursor-pointer mx-1 mx-md-3 mx-lg-4 pb-3">
                        <a :id="'outstanding-banner-' + (index+1)"  :title="bannerOutstanding.name" :href="bannerOutstanding.cta_link" target="_self" class="d-flex justify-content-center  w-100 mb-2 ">
                            <img :src="bannerOutstanding.image" :alt="bannerOutstanding.tittle" class="rounded-4 w-100 h-100">
                        </a>
                        <a :id="bannerOutstanding.id + '-boton-aqui'" :title="bannerOutstanding.name" :href="bannerOutstanding.cta_link" target="_self" class="fs-6 text-indigo text-title-bat text-decoration-none fw-bold border-blue-bottom border-2 pb-2 text-btn-outstanding">{{bannerOutstanding.cta_text}} ></a>
                    </div>
                </div>
            </slick>
        </div>
        <div v-if="bannersOutstanding &&  bannersOutstanding.length == 4">
            <slick v-if="bannersOutstanding && bannersOutstanding.length" ref="slick" :options="slickOptionsBannerOutstanding4" class=" slick-vue mb-3 slick-outstanding-home-4">
                <div v-for="(bannerOutstanding, index) in bannersOutstanding" :key="index" v-if="index < 10" class="px-1 px-mg-2 col-3 col-sm-3 col-lg-2">
                    <div class="cursor-pointer mx-1 mx-md-3 mx-lg-4 pb-3">
                        <a :id="'outstanding-banner-' + (index+1)" :title="bannerOutstanding.name" :href="bannerOutstanding.cta_link" target="_self" class="d-flex justify-content-center  w-100 mb-2 ">
                            <img :src="bannerOutstanding.image" :alt="bannerOutstanding.tittle" class="rounded-4 w-100 h-100">
                        </a>
                        <a :id="bannerOutstanding.id + '-boton-aqui'" :title="bannerOutstanding.name" :href="bannerOutstanding.cta_link" target="_self" class="fs-6 text-indigo text-title-bat text-decoration-none fw-bold border-blue-bottom border-2 pb-2 text-btn-outstanding">{{bannerOutstanding.cta_text}} ></a>
                    </div>
                </div>
            </slick>
        </div>
    </div>
</template>
<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
export default {
    components: { Slick },
    props: {
        url_media: {
            default: '',
        },
    },
    data() {
        return {
            bannersOutstanding: [],
            slickOptionsBannerOutstanding: {
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: false,
                slidesToShow: 4.2,
                slidesToScroll: 2,
                initialSlide:1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2.2,
                            slidesToScroll: 2,
                            variableWidth: false,
                            initialSlide:1,
                        }
                    }
                ]
            },
            slickOptionsBannerOutstandingV: {
                dots: false,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 2,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            centerMode: true,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ]
            },
            slickOptionsBannerOutstanding4: {
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                slidesToShow: 4,
                slidesToScroll: 2,
                centerMode: false,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2.2,
                            slidesToScroll: 2,
                            variableWidth: false,
                            initialSlide: 1,
                            infinite: true,
                        }
                    }
                ]
            },
        }
    },
    mounted () {
        this.loadOutstanding();
    },
    methods: {
        loadOutstanding(){
            axios.get(`outstanding-content`)
                .then((dataO) => {
                    this.bannersOutstanding = dataO.data.contents;
                })
        },
    }
}
</script>
